import apiClient from "./apiClient";
const hiringServicePath = "/api/v3/hiring";
const HOME_PATH = "/api/v3/home";

export const getPartnersListApi = async (params = {}) => {
  return apiClient.get("/api/v3/hiring/getPartnersList", {
    params,
  });
};
export const getAdminDetailsByOrgCodeapi = async (orgCode) => {
  const response = await apiClient.get(
    `${HOME_PATH}/getAdminDetailsByOrgCode?orgCode=${orgCode}`,
  );
  return response.data;
};

export const addPartnerApi = async (data) => {
  const response = await apiClient.post(
    `${hiringServicePath}/addPartner`,
    data,
  );
  return response.data;
};

export const editPartnerApi = async (data) => {
  const response = await apiClient.post(
    `${hiringServicePath}/editPartner`,
    data,
  );
  return response.data;
};

export const getPartnerByIdApi = async (id) => {
  const response = await apiClient.get(
    `${hiringServicePath}/getPartnerById?id=${id}`,
  );
  return response.data;
};

export const updatePartnerRequestApi = async (data) => {
  const response = await apiClient.post(
    `${hiringServicePath}/updatePartnerRequest`,
    data,
  );
  return response.data;
};

export const resendInvitationApi = async (data) => {
  const response = await apiClient.post(
    `${hiringServicePath}/resendInvitation`,
    data,
  );
  return response.data;
};

export const removePartnerConnectionApi = async (data) => {
  const response = await apiClient.post(
    `${hiringServicePath}/removeConnection`,
    data,
  );
  return response.data;
};

export const getJobRolesSharedByPartnerApi = async (data) => {
  const response = await apiClient.post(
    `${hiringServicePath}/getJobRolesSharedByPartners`,
    data,
  );
  return response.data;
};

export const getMatchesForjobRoleApi = async (data) => {
  const response = await apiClient.post(
    `${hiringServicePath}/getMatchesOfJobRoles`,
    data,
  );
  return response.data;
};

export const cancelInvitationApi = async (data) => {
  const response = await apiClient.post(
    `${hiringServicePath}/cancelInvitation`,
    data,
  );
  return response.data;
};

export const shortListPersonForJobRoleApi = async (data) => {
  const response = await apiClient.post(
    `${hiringServicePath}/shortlistPersonForJobRole`,
    data,
  );
  return response.data;
};

export const removePersonFromShortlistApi = async (data) => {
  const response = await apiClient.post(
    `${hiringServicePath}/removeShortlistForJobRole`,
    data,
  );
  return response.data;
};

export const getTop3RoleMatchesOfUserIdApi = async (userId) => {
  const response = await apiClient.post(
    `${hiringServicePath}/getTop3RoleMatchesOfUserId`,
    userId,
  );
  return response.data;
};

export const getShortlistedJobRolesApi = async (data) => {
  const response = await apiClient.post(
    `${hiringServicePath}/getShortlistedJobRoles`,
    data,
  );
  return response.data;
};

export const openShortlistedJobRoleApi = async (data) => {
  const response = await apiClient.post(
    `${hiringServicePath}/openShortlistedJobRole`,
    data,
  );
  return response.data;
};

export const updateShortlistNameApi = async (data) => {
  const response = await apiClient.post(
    `${hiringServicePath}/updateShortlistName`,
    data,
  );
  return response.data;
};

export const viewExternalProfileApi = async (data) => {
  const response = await apiClient.post(
    `${hiringServicePath}/viewExternalProfile`,
    data,
  );
  return response.data;
};

export const contactPartnerApi = async (data) => {
  const response = await apiClient.post(
    `${hiringServicePath}/contactPartner`,
    data,
  );
  return response.data;
};

export const notifyInterestApi = async (data) => {
  const response = await apiClient.post(
    `${hiringServicePath}/notifyInterest`,
    data,
  );
  return response.data;
};
